export default {
    topics: '/topics',
    attachments: '/attachments',
    filterTags: {
        search: ['GET', '/filter-tags/search'],
        calculateStat: ['POST', '/filter-tags/calculate-stat'],
    },
    quextUsers: '/quext-users',
};
